import { atomWithReset } from 'jotai/utils';
import type { FocusedSuggestionT } from '../../../../common/review-suggestions-side-panel';
const focusedSuggestionAtom = atomWithReset<FocusedSuggestionT | null>(null);
export { focusedSuggestionAtom };